import { css } from 'styled-components';

export const EmberGlowSkin = css`
  background: linear-gradient(145deg, #2b0f0a, #120604);
  border: 4px solid #ff6a3d;
  box-shadow:
    inset 0 0 10px rgba(255, 106, 61, 0.4),
    0 0 25px rgba(255, 80, 40, 0.5);
`;

export const EmberGlowWrapperSkin = css`
  background: radial-gradient(circle at center, #3a130b 0%, #0c0402 70%);
`;

export const EmberGlowLetterSkin = css<{ $isActive: boolean }>`
  color: ${({ $isActive }) => ($isActive ? '#ffb199' : '#5a2a1e')};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.25)};
  text-shadow: ${({ $isActive }) => ($isActive ? '0 0 8px rgba(255,120,80,0.8)' : 'none')};
`;
